import { z } from 'zod/v4-mini';
import { matchingZodObject, matchingZodObjectLoose } from '../utilities/matchingZodObject.js';
/**
 * Validate that the package.json includes the name and version, and pass through all other fields
 * without validation.
 */
const ZodBasicPackageJson = matchingZodObjectLoose({
    name: z.string(),
    version: z.string(),
});
export const ZodNotifyLinkChangeInput = matchingZodObject({
    packagePath: z.string(),
    hash: z.optional(z.string()),
    definition: z.optional(ZodBasicPackageJson),
});
//# sourceMappingURL=NotifyLinkChangeInput.js.map